import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Layout from './components/layout';
import TicketList from './components/Ticketlist';
import Dashboard from './components/Dashboard';
import Login from './components/login';
import config from './config';
import Completeprofile from './components/Completeprofile';
import Attendance from './components/Attendance';

function App() {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkUserLoggedIn = () => {
      const storedUser = JSON.parse(localStorage.getItem('user'));
      console.log(storedUser);  
      if (storedUser) {
        setUser(storedUser);
        // Assuming the user object has a 'role' property. Adjust this condition based on your user data structure.
        setIsAdmin(storedUser.isAdmin === "True");
      }
      setIsLoading(false);
    };

    checkUserLoggedIn();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
    setIsAdmin(false);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login setUser={setUser} setIsAdmin={setIsAdmin} />} />
        <Route
          path="/*"
          element={
            user ? (
              <Layout isAdmin={isAdmin} user={user} handleLogout={handleLogout}>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Dashboard user={user} />} />
                  <Route path="/tickets" element={<TicketList isAdmin={isAdmin} user={user} />} />
                  <Route path="/CompleteProfile" element={<Completeprofile user={user} />} />
                  <Route path="/attendance" element={<Attendance user={user} />} />
                  {/* Add more routes as needed */}
                </Routes>
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
